import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./feature/pages/auth/auth.module').then(mod => mod.AuthModule),
    canActivate: [],
  },
  {
    path: 'auth',
    loadChildren: () => import('./feature/pages/auth/auth.module').then(mod => mod.AuthModule),
    canActivate: [],
  },
  {
    path: 'pages',
    loadChildren: () => import('./feature/pages/pages.module').then(mod => mod.PagesModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'privacy-policy',
    loadChildren: () => import('./feature/privacy-policy/privacy-policy.module').then(mod => mod.PrivacyPolicyModule),
    canActivate: [],
  },
  {
    path: 'support',
    loadChildren: () => import('./feature/support/support.module').then(mod => mod.SupportModule),
    canActivate: [],
  },
  {
    path: 'copyright',
    loadChildren: () => import('./feature/copyright/copyright.module').then(mod => mod.CopyrightModule),
    canActivate: [],
  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    relativeLinkResolution: 'legacy'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
